import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_HierarchyManagementMasterTab = _resolveComponent("HierarchyManagementMasterTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_HierarchyManagementTechnicalTab = _resolveComponent("HierarchyManagementTechnicalTab")
  const _component_HierarchyManagementBackupTab = _resolveComponent("HierarchyManagementBackupTab")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
            key: 0,
            class: "kn-progress-spinner",
            "data-test": "spinner"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_TabView, { class: "hierarchy-tabview kn-height-full" }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.hierarchyManagement.master')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_HierarchyManagementMasterTab, {
                dimensions: _ctx.dimensions,
                onLoading: _ctx.setLoading
              }, null, 8, ["dimensions", "onLoading"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.hierarchyManagement.technical')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_HierarchyManagementTechnicalTab, {
                dimensions: _ctx.dimensions,
                onLoading: _ctx.setLoading
              }, null, 8, ["dimensions", "onLoading"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.hierarchyManagement.backup')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_HierarchyManagementBackupTab, { dimensions: _ctx.dimensions }, null, 8, ["dimensions"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}